const text = value => typeof value === 'string' ? value.trim() : ''

export function loadIdentity(record) {
  if (!record || typeof record !== 'object' || !('employee_name' in record || 'driver_name_snapshot' in record)) return record
  return { ...record, employee_name: text(record.driver_name_snapshot) || text(record.employee_name),
    employee_phone: text(record.driver_phone_snapshot) || text(record.employee_phone) }
}

export function loadIdentityResponse(response) {
  const data = response?.data
  if (Array.isArray(data)) return { ...response, data: data.map(loadIdentity) }
  if (Array.isArray(data?.results)) return { ...response, data: { ...data, results: data.results.map(loadIdentity) } }
  return response && { ...response, data: loadIdentity(data) }
}
